import { UpdateUserAppVersionRequest, VersionInfo } from 'features/appStatus/types';
import { WellframeApi } from 'store/api';
import { getBaseSubPath } from 'utils';

export const appStatusService = WellframeApi.injectEndpoints({
  endpoints: (builder) => ({
    getAppVersion: builder.query<VersionInfo, void>({
      queryFn: async () => {
        try {
          const response = await fetch(`${getBaseSubPath()}/version`);
          const data = await response.json();
          return { data };
        } catch (error) {
          return {
            error: {
              status: 500,
              data: {
                error: error instanceof Error ? error.message : 'Failed to fetch version',
                errors: {},
              },
            },
          };
        }
      },
    }),
    updateUserAppVersion: builder.mutation<null, UpdateUserAppVersionRequest>({
      query: ({ id, version }) => ({
        url: `/api/gambit/v1/program_users/${id}`,
        method: 'PATCH',
        body: {
          program_user: {
            mobile_app_version: version,
          },
        },
      }),
    }),
  }),
});

export const { useGetAppVersionQuery, useUpdateUserAppVersionMutation } = appStatusService;
